@import "../../shared";

.icon-chooser {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  position: relative;
  margin-bottom: 1.5rem;
  padding: 0;
  list-style-type: none;

  .form-radio {
    flex-direction: column;
    align-items: center;
    margin: 0;
  }

  .form-radio__caption {
    display: block;
    font-size: $font-size-small;
    min-height: 0.5rem; // for caption-less picker to keep shadow visible
  }
}

.icon-chooser-list__item {
  // Use long-hand flex property for IE11. See
  // https://github.com/philipwalton/flexbugs#8-flex-basis-doesnt-support-calc
  flex: 1 1 auto;
  color: $blue;
  &:hover{
    color: $dark-purple;
  }
}

.icon-chooser.activityIcons {
  & > .icon-chooser-list__item {
    flex: 25%;
    padding: 1rem;
  }

  .form-radio__caption {
    max-width: 95%;
    word-wrap: break-word;
    text-align: center;
    font-weight: bold;
    margin-top: 0.2rem;
  }
}

.icon-chooser--small .form-radio__image-container {
  width: 6rem;
  height: 6rem;
}

.icon-chooser--large .form-radio__image-container {
  width: 12rem;
  height: 12rem;
}
